export default __webpack_public_path__ + "1c7f8c339bc12ddf4dce837f67789e89.png";